// src/pages/solusi/SmartHome.jsx
import React, { useEffect } from 'react';

const SmartHome = () => {
  useEffect(() => {
    // --- SEO Meta Tags untuk Halaman Smart Home ---
    document.title = "Smart Home: Otomatiskan Rumah Anda, Aman & Nyaman | Solusi IoT Cerdas";

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "Wujudkan rumah pintar impian Anda dengan solusi Smart Home berbasis IoT. Otomatisasi lampu, keamanan pintu RFID, pengawasan suhu, dan kendali perangkat dari mana saja. Hemat energi, tingkatkan keamanan, dan ciptakan kenyamanan maksimal.");

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', "smart home, rumah pintar, otomatisasi rumah, IoT rumah, lampu otomatis, kunci pintu RFID, keamanan rumah, kendali suhu pintar, ESP32 smart home, solusi rumah cerdas");

    // Open Graph Tags
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) { ogTitle = document.createElement('meta'); ogTitle.setAttribute('property', 'og:title'); document.head.appendChild(ogTitle); }
    ogTitle.setAttribute('content', "Smart Home: Otomatiskan Rumah Anda, Aman & Nyaman | Solusi IoT Cerdas");

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) { ogDescription = document.createElement('meta'); ogDescription.setAttribute('property', 'og:description'); document.head.appendChild(ogDescription); }
    ogDescription.setAttribute('content', "Wujudkan rumah pintar impian Anda dengan solusi Smart Home berbasis IoT. Otomatisasi lampu, keamanan pintu RFID, pengawasan suhu, dan kendali perangkat dari mana saja. Hemat energi, tingkatkan keamanan, dan ciptakan kenyamanan maksimal.");

    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) { ogType = document.createElement('meta'); ogType.setAttribute('property', 'og:type'); document.head.appendChild(ogType); }
    ogType.setAttribute('content', "website");

    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (!ogUrl) { ogUrl = document.createElement('meta'); ogUrl.setAttribute('property', 'og:url'); document.head.appendChild(ogUrl); }
    ogUrl.setAttribute('content', "https://www.solusiiotcerdas.com/solusi/smart-home"); // Ganti dengan URL domain Anda untuk halaman ini

    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) { ogImage = document.createElement('meta'); ogImage.setAttribute('property', 'og:image'); document.head.appendChild(ogImage); }
    ogImage.setAttribute('content', "https://via.placeholder.com/1200x630/6A5ACD/FFFFFF?text=Smart+Home+IoT"); // Ganti dengan URL gambar relevan untuk Smart Home

    // Twitter Card Tags
    let twitterCard = document.querySelector('meta[name="twitter:card"]');
    if (!twitterCard) { twitterCard = document.createElement('meta'); twitterCard.setAttribute('name', 'twitter:card'); document.head.appendChild(twitterCard); }
    twitterCard.setAttribute('content', "summary_large_image");

    let twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (!twitterImage) { twitterImage = document.createElement('meta'); twitterImage.setAttribute('name', 'twitter:image'); document.head.appendChild(twitterImage); }
    twitterImage.setAttribute('content', "https://via.placeholder.com/1200x630/6A5ACD/FFFFFF?text=Smart+Home+IoT"); // Ganti dengan URL gambar relevan untuk Smart Home

    return () => {
      // Cleanup opsional jika diperlukan
    };
  }, []);

  return (
    <>
      <div className="bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200 min-h-screen py-16 transition-colors duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* 1. Hero Section */}
          <section className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-extrabold text-purple-700 dark:text-purple-400 leading-tight mb-4">
              Wujudkan Rumah Impian Anda: Aman, Nyaman, dan Otomatis dengan Smart Home IoT
            </h1>
            <p className="text-lg md:text-xl max-w-3xl mx-auto text-gray-700 dark:text-gray-300">
              Ubah rumah Anda menjadi tempat tinggal cerdas dengan teknologi IoT. Kendalikan semuanya dari genggaman tangan Anda!
            </p>
          </section>

          {/* 2. Masalah yang Sering Dihadapi di Rumah Biasa */}
          <section className="mb-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">Tantangan Keseharian di Rumah?</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div className="text-center md:text-left">
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 text-lg space-y-3">
                  <li className="flex items-center"><span className="text-red-500 text-2xl mr-2">💡</span>Lupa matikan lampu saat pergi</li>
                  <li className="flex items-center"><span className="text-red-500 text-2xl mr-2">🔑</span>Khawatir keamanan pintu rumah</li>
                  <li className="flex items-center"><span className="text-red-500 text-2xl mr-2">🌡️</span>Suhu ruangan tidak nyaman</li>
                  <li className="flex items-center"><span className="text-red-500 text-2xl mr-2">⏰</span>Membuang waktu untuk rutinitas rumah</li>
                </ul>
              </div>
              <div className="flex justify-center">
                <img
                  src="/images/smart-home/smart-home-challenges.webp" // Ganti dengan gambar relevan
                  alt="Tantangan Rumah Konvensional"
                  className="rounded-lg shadow-xl w-full h-auto max-w-sm"
                />
              </div>
            </div>
          </section>

          {/* 3. Solusi Kami: Smart Home Berbasis IoT */}
          <section className="mb-16 bg-gray-50 dark:bg-gray-950 p-8 rounded-lg shadow-md transition-colors duration-300">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">💡 Solusi Kami: Rumah Pintar Impian Anda</h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 max-w-4xl mx-auto text-center mb-8">
              Dengan sistem Smart Home berbasis ESP32 dan berbagai sensor, kami membantu Anda:
            </p>
            <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 text-lg space-y-2 max-w-2xl mx-auto">
              <li>Otomatisasi perangkat rumah untuk kenyamanan optimal.</li>
              <li>Meningkatkan keamanan dengan sistem akses cerdas.</li>
              <li>Menghemat energi dan biaya operasional rumah.</li>
              <li>Memantau dan mengendalikan rumah dari mana saja via smartphone.</li>
            </ul>
          </section>

          {/* 4. Fitur Unggulan Sistem Smart Home */}
          <section className="mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">✨ Fitur Unggulan Sistem Kami</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Fitur 1: Lampu Otomatis */}
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <div className="text-4xl text-yellow-500 dark:text-yellow-300 mb-4">💡</div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Lampu Otomatis Berbasis Gerak & Waktu</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Lampu menyala saat ada gerakan, atau sesuai jadwal, dan mati otomatis saat tidak diperlukan. Hemat listrik dan praktis.</p>
              </div>
              {/* Fitur 2: Kunci Pintu RFID */}
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <div className="text-4xl text-blue-500 dark:text-blue-300 mb-4">🔒</div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Kunci Pintu Pintar (RFID / Fingerprint)</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Akses pintu tanpa kunci fisik. Gunakan kartu RFID, sidik jari, atau bahkan aplikasi smartphone untuk keamanan ekstra.</p>
              </div>
              {/* Fitur 3: Kontrol Suhu Otomatis */}
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <div className="text-4xl text-red-500 dark:text-red-300 mb-4">🌡️</div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Manajemen Suhu & Kelembaban</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Pantau dan atur suhu ruangan secara otomatis menggunakan sensor DHT11/22 terhubung ke AC atau kipas.</p>
              </div>
              {/* Fitur 4: Monitor Kualitas Udara */}
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <div className="text-4xl text-green-500 dark:text-green-300 mb-4">🍃</div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Pemantau Kualitas Udara dalam Ruangan</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Deteksi tingkat CO, VOC, atau partikel debu (PM2.5) dan beri notifikasi atau aktifkan pembersih udara.</p>
              </div>
              {/* Fitur 5: Sistem Keamanan Komprehensif */}
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <div className="text-4xl text-orange-500 dark:text-orange-300 mb-4">🚨</div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Deteksi Kebocoran Gas & Asap</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Peringatan dini kebocoran gas (LPG/LNG) atau asap kebakaran dengan sensor MQ-series dan sirene.</p>
              </div>
              {/* Fitur 6: Kontrol Perangkat Jarak Jauh */}
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <div className="text-4xl text-purple-500 dark:text-purple-300 mb-4">📱</div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Kontrol Perangkat via Aplikasi</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Atur semua perangkat pintar Anda dari satu aplikasi di smartphone, di mana pun Anda berada.</p>
              </div>
            </div>
          </section>

          {/* 5. Bagaimana Sistem Ini Bekerja? (Contoh Lampu Otomatis) */}
          <section className="mb-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">⚙️ Contoh Cara Kerja: Lampu Otomatis</h2>
            <div className="flex flex-col md:flex-row items-center justify-around text-center space-y-8 md:space-y-0 md:space-x-8">
              <div className="flex flex-col items-center max-w-xs">
                <div className="text-5xl text-gray-600 dark:text-gray-400 mb-4">🚶</div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Sensor Gerak (PIR)</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Mendeteksi keberadaan orang atau gerakan.</p>
              </div>
              <div className="text-5xl text-gray-400 dark:text-gray-600 hidden md:block">→</div>
              <div className="flex flex-col items-center max-w-xs">
                <div className="text-5xl text-blue-600 dark:text-blue-400 mb-4">💡</div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Sensor Cahaya (LDR)</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Mendeteksi tingkat cahaya sekitar.</p>
              </div>
              <div className="text-5xl text-gray-400 dark:text-gray-600 hidden md:block">→</div>
              <div className="flex flex-col items-center max-w-xs">
                <div className="text-5xl text-green-600 dark:text-green-400 mb-4">💻</div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">ESP32 & Logika</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Memproses data dari sensor dan mengontrol relay.</p>
              </div>
              <div className="text-5xl text-gray-400 dark:text-gray-600 hidden md:block">→</div>
              <div className="flex flex-col items-center max-w-xs">
                <div className="text-5xl text-yellow-600 dark:text-yellow-400 mb-4">⚡</div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Relay & Lampu</h3>
                <p className="text-gray-600 dark:text-gray-300 text-sm">Secara otomatis menyalakan/mematikan lampu.</p>
              </div>
            </div>
            <p className="text-center text-gray-600 dark:text-gray-300 mt-8">Sistem ini dapat diintegrasikan dengan jadwal waktu dan kendali manual via aplikasi untuk fleksibilitas penuh.</p>
          </section>

          {/* 6. Untuk Siapa Sistem Ini? */}
          <section className="mb-16 bg-gray-50 dark:bg-gray-950 p-8 rounded-lg shadow-md transition-colors duration-300">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">🏡 Smart Home Cocok Untuk Siapa?</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <img src="/images/smart-home/target-pemilik-rumah.webp" alt="Pemilik Rumah Pribadi" className="mx-auto mb-4 w-32 h-32 object-contain" />
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Pemilik Rumah Pribadi</h3>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <img src="/images/smart-home/target-villa-kosan.webp" alt="Villa & Kos-kosan Modern" className="mx-auto mb-4 w-32 h-32 object-contain" />
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Villa & Kos-kosan Modern</h3>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <img src="/images/smart-home/target-kantor-kecil.webp" alt="Kantor Kecil & Ruang Kerja" className="mx-auto mb-4 w-32 h-32 object-contain" />
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Kantor Kecil & Ruang Kerja</h3>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <img src="/images/smart-home/target-apartemen-studio.webp" alt="Apartemen Studio" className="mx-auto mb-4 w-32 h-32 object-contain" />
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Apartemen Studio</h3>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <img src="/images/smart-home/target-orang-tua.webp" alt="Keluarga dengan Orang Tua" className="mx-auto mb-4 w-32 h-32 object-contain" />
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Keluarga dengan Lansia</h3>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md text-center transform hover:scale-105 transition-all duration-300">
                <img src="/images/smart-home/target-pengembang-properti.webp" alt="Pengembang Properti" className="mx-auto mb-4 w-32 h-32 object-contain" />
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Pengembang Properti</h3>
              </div>
            </div>
          </section>

          {/* 7. Testimoni Pengguna */}
          <section className="mb-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">🗣️ Kata Mereka yang Sudah Merasakan Smart Home</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-gray-100 dark:bg-gray-700 p-6 rounded-lg shadow-sm">
                <p className="text-lg italic text-gray-700 dark:text-gray-300 mb-4">
                  “Sangat terbantu, lampu rumah tidak pernah lupa mati lagi. Hemat listrik dan praktis!”
                </p>
                <p className="font-semibold text-gray-800 dark:text-gray-200">
                  — Bpk. Surya, Pemilik Rumah, Depok
                </p>
              </div>
              <div className="bg-gray-100 dark:bg-gray-700 p-6 rounded-lg shadow-sm">
                <p className="text-lg italic text-gray-700 dark:text-gray-300 mb-4">
                  “Fitur kunci RFID memberikan rasa aman ekstra. Tidak perlu khawatir kunci hilang lagi.”
                </p>
                <p className="font-semibold text-gray-800 dark:text-gray-200">
                  — Ibu Diana, Pengelola Kos-kosan, Jakarta
                </p>
              </div>
            </div>
          </section>

          {/* 8. Call To Action */}
          <section className="text-center mt-16 bg-purple-600 dark:bg-purple-900 text-white p-8 rounded-lg shadow-lg">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">📞 Wujudkan Rumah Pintar Anda Sekarang!</h2>
            <p className="text-lg mb-6">
              Mulai dari **Rp 800.000*** untuk paket dasar:
            </p>
            <ul className="list-disc list-inside text-white text-lg mb-8 max-w-lg mx-auto text-left">
              <li>Modul kontrol utama (ESP32)</li>
              <li>Sensor pilihan (misal: sensor gerak atau RFID)</li>
              <li>Dashboard monitoring & kontrol aplikasi</li>
              <li>Instalasi dasar & konsultasi</li>
            </ul>
            <p className="text-sm text-purple-100 dark:text-purple-200 mb-6">
              *Harga dapat disesuaikan berdasarkan kustomisasi dan jumlah fitur.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a
                href="https://www.solusiiotcerdas.id/kontak" // Ganti dengan URL halaman kontak/demo Smart Home Anda
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-purple-600 dark:bg-purple-200 dark:text-purple-900 font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50"
              >
                🔗 Pelajari Lebih Lanjut
              </a>
              <a
                href="https://wa.me/6285773745006?text=Halo%2C%20saya%20tertarik%20dengan%20Sistem%20Smart%20Home%20yang%20Anda%20tawarkan.%20Bisa%20diberikan%20informasi%20lebih%20lanjut%3F" // Ganti dengan nomor WA Anda
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-green-500 text-white dark:bg-green-700 dark:text-green-100 font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-green-600 dark:hover:bg-green-800 transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
              >
                📱 Konsultasi Gratis
              </a>
            </div>
          </section>

          {/* 9. Video Penjelasan/Demo Smart Home (Ganti URL YouTube ini) */}
          <section className="my-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">▶️ Demo & Penjelasan Sistem Smart Home</h2>
            <div className="aspect-w-16 aspect-h-9 w-full max-w-xl mx-auto">
              {/* GANTI URL INI dengan URL embed YouTube video demo Smart Home Anda */}
              <iframe
                src="https://www.youtube.com/embed/GTok4cT1H3o?si=0eI9Mh5lANeieIEX" // Ganti 'your-smarthome-video-id' dengan ID video demo Smart Home Anda
                title="Video Demo Sistem Smart Home"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="w-full h-full"
              ></iframe>
            </div>
            <p className="text-center text-gray-600 dark:text-gray-300 mt-4">Saksikan bagaimana Smart Home kami meningkatkan kenyamanan dan keamanan Anda.</p>
          </section>

          {/* 10. Tampilan Aplikasi Smart Home (Ganti gambar ini) */}
          <section className="my-16 text-center bg-gray-50 dark:bg-gray-950 p-8 rounded-lg shadow-md transition-colors duration-300">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 mb-8">📲 Tampilan Aplikasi Kontrol Smart Home</h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 mb-6">Kontrol semua perangkat pintar Anda dengan mudah dari smartphone Anda.</p>
            <div className="flex justify-center items-center">
              {/* GANTI GAMBAR INI dengan screenshot aplikasi Smart Home Anda (lokasi: public/images/smart-home/app-screenshot.webp) */}
              <img
                src="/images/smart-home/smarthome-app-screenshot.webp" // Contoh path gambar, sesuaikan jika berbeda
                alt="Screenshot Aplikasi Kontrol Smart Home"
                className="mx-auto rounded-lg shadow-xl w-full max-w-xl h-auto"
              />
            </div>
            <p className="text-center text-gray-600 dark:text-gray-300 mt-4">Desain antarmuka yang intuitif dan mudah digunakan.</p>
          </section>

          {/* 11. Peta Lokasi Kami (Sama seperti Smart Water Monitor) */}
          <section className="my-16 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md transition-colors duration-300">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 text-center mb-8">📍 Lokasi Kami di Depok, Jawa Barat</h2>
            <div className="aspect-w-16 aspect-h-9 w-full max-w-2xl mx-auto">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3965.1935431785923!2d106.8806544!3d-6.3689941!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69ed7fbef21df7%3A0x7f0ed1ec7aafb50d!2sSolusi%20IoT%20Cerdas!5e0!3m2!1sid!2sid!4v1750815831643!5m2!1sid!2sid" // URL Maps kamu
                title="Lokasi Kantor Solusi IoT Cerdas di Depok" // Judul yang deskriptif
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-full"
              ></iframe>
            </div>
            <p className="text-center text-gray-600 dark:text-gray-300 mt-4">Kunjungi kami atau hubungi kami untuk informasi lebih lanjut.</p>
          </section>

        </div>
      </div>
    </>
  );
};

export default SmartHome;